import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { format, parseISO } from 'date-fns';
import { EoDetailItemType } from './eo-detail-item-config.model';

@Component({
  selector: 'eo-detail-item',
  templateUrl: './eo-detail-item.component.html',
  styleUrls: ['./eo-detail-item.component.scss'],
})
export class EoDetailItemComponent implements OnInit {
  format = format;
  parseISO = parseISO;

  @Input() loading = false;
  @Input() title = '';
  @Input() helpTitle: string | null = null;
  @Input() value: any = '';
  @Input() isRequired = false;
  @Input() valueType: EoDetailItemType = 'text';
  @Input() severity:
    | 'success'
    | 'info'
    | 'warning'
    | 'danger'
    | 'help'
    | 'primary'
    | 'secondary'
    | 'contrast'
    | null
    | undefined = 'info'; //'info' | 'success' | 'error' | 'warn' = 'info';

  @Input() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {}

  fileExtention() {
    let fe = this.value?.fileName?.split('.')?.reverse()[0];
    if (!fe) fe = this.value?.name?.split('.')?.reverse()[0];
    if (!fe) return 'times-circle';

    switch (fe) {
      case 'doc':
        return 'file-word';
      case 'docx':
        return 'file-word';
      case 'xls':
        return 'file-excel';
      case 'pdf':
        return 'file-pdf';
      case 'jpg':
        return 'image';
      case 'png':
        return 'image';
      case 'gif':
        return 'image';
    }
    return 'file';
  }

  getColorBySeverity() {
    switch (this.severity) {
      case 'success':
        return 'var(--green-400)';
      case 'warning':
        return 'var(--orange-400)';
      case 'danger':
        return 'var(--red-400)';
      default:
        return 'var(--black-900)';
    }
  }

  isBoolean(value: any) {
    return typeof value === 'boolean';
  }

  toDateString(value: string) {
    let dateStr = value;
    try {
      dateStr = format(parseISO(value), 'dd/MM/yyyy');
    } catch (e) {}

    return dateStr;
  }

  getSafeHtml(value: string) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
